export const NAME_COLUMN_PERCENTAGE = 70;
export const LAST_FULFILLED_COLUMN_PERCENTAGE = 30;

export const MIN_NAME_COLUMN_SIZE = 280;
export const MIN_COLUMN_SIZE = 120;

export const ESTIMATED_HEADER_HEIGHT = 40;
export const ESTIMATED_ROW_HEIGHT = 56;
